export const blogData = [
    {
        id: 1,
        title: 'Unifeed blog',
        description: '',
        date: '1/12/2022',
        image: '',
        url: 'https://misathemeb.github.io/Unifeed_blog_1.12.22/index.html'
    },
    {
        id: 2,
        title: 'CLONING RELIANCE DIGITAL',
        description: 'Experience of the second project.',
        date: 'Jan 23, 2022',
        image: 'https://miro.medium.com/max/875/1*nY9cUfzwtDaM6lGyvj4STg.png',
        url: 'https://medium.com/@sreerag.rajan5/cloning-reliance-digital-439cd56d46a3'
    },
    {
        id: 3,
        title: 'Reliance Digital Clone (Part II)',
        description: 'The experience of the third project, with a focus on leadership skills',
        date: 'Feb 27, 2022',
        image: 'https://miro.medium.com/max/875/1*qRNfRbuHCDC1ct0chLZoWA.png',
        url: 'https://medium.com/@sreerag.rajan5/reliance-digital-clone-part-ii-57797eaf1ddf'
    },
    
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/